<template>
  <!-- 导航栏 -->
  <div class="header system-header-box" :class="{ scrolled: isScrolled }" @mouseleave="moveType">
    <!-- <Lnotice /> -->
    <!-- pc -->
    <!-- app fixed  -->
    <v-app-bar v-if="$vuetify.breakpoint.lgAndUp" class="nav-box-pc" flat>
      <transition name="fade">
        <LhomeDialog v-show="navDialog" :type="dialogType" @hide="moveType" />
      </transition>
      <div class="system-header">
        <router-link :to="{ name: 'index' }">
          <img id="nav-logo" :src="logo" alt="logo" @mouseenter="moveType" />
        </router-link>
        <!-- 导航目录 -->
        <ul class="tab-box">
          <li v-for="(item, index) in $store.state.system.menuList" :key="index" class="tab-text" :class="{ active: dialogType == item }" @mouseenter="getType(item)" @click="toList(item)">
            {{ item }}
          </li>
        </ul>
        <v-spacer />
        <!-- pc右侧-------------------------------------------------------------------------------- -->
        <!-- 搜索 -->
        <div class="input-search" @mouseover="searchDom('on')" @mouseleave="searchDom('off')" @click="changeCom('search')">
          <img :src="search" class="search-icon" alt="search" />
          <span>Search</span>
        </div>
        <!-- 个人中心 -->
        <div class="option-box">
          <div class="option" @click="toCollection">
            <img class="items img1" src="/imgs/collection.png" alt="collection" />
            <span v-if="CollectionsAndCartsNum.collect" class="flag-num">{{ CollectionsAndCartsNum.collect }}</span>
          </div>
          <div class="option" @click="toCart">
            <img class="items img2" src="/imgs/shopping_cart.png" alt="shopping_cart" />
            <span v-if="CollectionsAndCartsNum.cart" class="flag-num">{{ CollectionsAndCartsNum.cart }}</span>
          </div>
          <v-menu offset-y nudge-left="100" z-index="9999" attach=".system-header-box">
            <template #activator="{ on, attrs }">
              <div class="option" v-bind="attrs" v-on="on"><img class="items img3" src="/imgs/personal.png" alt="personal" /></div>
            </template>
            <div class="center-list">
              <div class="content">
                <template v-if="userToken && userToken != ''">
                  <div class="header-name">
                    <img class="logo-user" src="/imgs/loading-logo.gif" alt="logo-user" />
                    <span>Hi, {{ userName }}</span>
                  </div>
                  <div class="item">
                    <v-btn block depressed class="my-btn" tile color="#fff" @click="toUser('account')">My Account</v-btn>
                    <v-btn block depressed class="my-btn" tile color="#fff" @click="toUser('order')">My Orders</v-btn>
                    <v-btn block depressed class="my-btn footer-option" color="#fff" @click="logOut">Log Out</v-btn>
                  </div>
                </template>
                <template v-else>
                  <div class="top">
                    <v-btn block depressed class="my-btn btn-login" tile color="#3067F2" @click="toLogin(0)">Sign In</v-btn>
                    <v-btn block depressed class="my-btn btn-register" tile color="#fff" @click="toLogin(1)">Create Account</v-btn>
                    <!-- <div class="other-tips">
                      <span class="line"></span>
                      <span class="tips"> Alternatively, login with </span>
                      <span class="line"></span>
                    </div>
                    <div class="other">
                      <span class="login-item item1">
                        <img src="/imgs/facebook2.png" alt="facebook-logo" />
                        Facebook
                      </span>
                      <span class="login-item item2">
                        <img src="/imgs/google.png" alt="facebook-logo" />
                        Google
                      </span>
                    </div> -->
                  </div>
                  <div class="bottom"></div>
                </template>
              </div>
            </div>
          </v-menu>
          <div class="line"></div>
        </div>
        <!-- 切换货币 -->
        <div class="text-center language-box">
          <span class="language-text">{{ $store.state.system.currencyList[$store.state.system.currencyIndx].value }}</span>
          <!-- <v-menu offset-y z-index="9999" attach=".system-header-box">
            <template #activator="{ on, attrs }">
              <div class="language" title="Currency" v-bind="attrs" v-on="on">
                <img class="language-icon" :src="`${$store.state.system.currencyList[$store.state.system.currencyIndx].icon}`" alt="country" />
                <span class="language-text">{{ $store.state.system.currencyList[$store.state.system.currencyIndx].value }}</span>
                <img class="open" src="/imgs/open.png" alt="countrySelect" />
              </div>
            </template>
            <v-list class="currency">
              <v-list-item-group v-model="selectedItem" color="#3067f2">
                <v-list-item v-for="(item, index) in $store.state.system.currencyList" :key="index">
                  <v-list-item-title>
                    <img class="country" :src="`${item.icon}`" :alt="item.value" />
                    {{ item.value }}
                  </v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu> -->
        </div>
      </div>
    </v-app-bar>
    <!-- mobile导航栏-------------------------------------------------------------- -->
    <v-app-bar v-if="$vuetify.breakpoint.mdAndDown" ref="nobileNav" class="nav-box-mobile d-lg-none d-xl-none" flat>
      <div class="system-header">
        <div class="left-nav">
          <img class="menu-iocn" :src="menuIcon" alt="menuIcon" @click="openMenu" />
          <img class="m-search" :src="search" alt="search" @click="$router.push({ name: 'control-search' })" />
        </div>
        <div class="center-nav">
          <router-link :to="{ name: 'index' }">
            <img id="logo" ref="logos" class="m-logo" :src="logo" alt="logo" />
          </router-link>
        </div>
        <div class="right-nav">
          <div class="nav-item">
            <img class="cart-icon" src="/imgs/shopping_cart.png" alt="shopping_cart" @click="toCart" />
            <span v-if="CollectionsAndCartsNum.cart" class="flag-num">{{ CollectionsAndCartsNum.cart }}</span>
          </div>
          <div class="nav-item">
            <img class="user-icon" src="/imgs/personal.png" alt="personal" @click="toCenter" />
          </div>
        </div>
        <!-- <div class="option" @click="toCart"></div>
 <div class="option" v-bind="attrs" v-on="on"></div> -->
      </div>
    </v-app-bar>
    <!-- 登录窗口 -->
    <!-- <Llogin :tab="loginTab" /> -->
    <Llogin />
    <resetPassword />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { typeName } from '@/assets/utils/renderData'
import LhomeDialog from '@/components/LhomeDialog/index.vue'
import Llogin from '@/components/Llogin/index.vue'
import resetPassword from '@/components/Llogin/resetPassword.vue'
import menuIcon from '@/static/imgs/menu3.png'
import search1 from '@/static/imgs/search.png'
import search2 from '@/static/imgs/search3.png'
export default {
  name: 'LNavbar',
  components: {
    LhomeDialog,
    Llogin,
    resetPassword
  },
  data() {
    return {
      tab: '',
      text: '',
      logo: require('@/static/imgs/logo.png'),
      menuIcon,
      search: search1,
      // menuList: ['Eyeglasses', 'Sunglasses', 'New Arrivals', 'Flash Sale', 'Best Sellers', 'Accessories'],
      // drawer: false,
      group: null,
      dialogType: null, // 弹窗所属
      dialog: false, // 登录
      // loginTab: 0, // 打开登录窗口模式 (登录 - 注册)
      scrollTop: 0, // 当前滑动距离
      isScrolled: false,
      hoverTimer: null // 悬停延迟定时器
    }
  },
  computed: {
    selectedItem: {
      get() {
        return this.$store.state.system.currencyIndx
      },
      set(value) {
        this.$store.commit('system/toggleCurrency', value)
      }
    },
    ...mapState({
      // 导航弹窗
      navDialog: state => state.system.navDialog,
      userName: state => {
        if (state.system.userInfo.firstname && state.system.userInfo.lastname) {
          return state.system.userInfo.firstname + ' ' + state.system.userInfo.lastname || ' '
        } else if (state.system.userInfo.firstname) {
          return state.system.userInfo.firstname
        } else {
          return ''
        }
      },
      userToken: state => state.system.userToken,
      CollectionsAndCartsNum: state => state.system.CollectionsAndCartsNum
    })
  },

  watch: {
    // nav弹窗出现时 幕遮层
    navDialog(newValue) {
      this.$store.commit('system/toggleOverlay', newValue)
    },
    // 系统货币设置
    selectedItem(newValue) {
      this.$store.commit('system/toggleCurrency', newValue)
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    // 清除悬停定时器
    if (this.hoverTimer) {
      clearTimeout(this.hoverTimer)
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch('system/logOut')
    },
    toList(item) {
      if (item === 'Accessories') {
        this.$router.push({
          name: 'search-accessories',
          params: {
            type: 'accessories'
          }
        })
        return false
      }
      this.$router.push({
        name: 'search-type',
        params: {
          type: typeName(item)
        }
      })
    },
    // 移入导航
    getType(name) {
      const hasDialog = ['Eyeglasses', 'Sunglasses']
      if (hasDialog.includes(name)) {
        // 清除之前的定时器
        if (this.hoverTimer) {
          clearTimeout(this.hoverTimer)
        }
        // 延迟 250ms 后触发弹窗
        this.hoverTimer = setTimeout(() => {
          this.dialogType = name
          this.$store.commit('system/toggleNavLog', true)
        }, 250)
      } else {
        this.moveType()
      }
    },
    // 移除导航
    moveType() {
      // 清除悬停定时器
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer)
        this.hoverTimer = null
      }
      this.$store.commit('system/toggleNavLog', false)
      this.dialogType = null
    },
    // 切换导航组件dialog
    changeCom(name) {
      if (name === 'search') {
        this.dialogType = name
        this.$store.commit('system/toggleNavLog', true)
      }
    },
    openMenu() {
      this.$store.commit('system/saveGoFrom', { name: this.$route.name, query: this.$route.query, params: this.$route.params })
      this.$router.push({ name: 'control' })
    },
    // 去购物车
    toCart() {
      this.$router.push({
        name: 'shoppingCart'
      })
    },
    toCollection() {
      if (this.userToken && this.userToken !== '') {
        this.$router.push({
          name: 'centerMain-personalization-wishlist'
        })
      } else {
        this.toLogin()
      }
    },
    // 打开登录
    toLogin(type = 0) {
      // this.loginTab = type
      this.$store.commit('system/loginDialogTab', type)
      this.$store.commit('system/toggleLogin', true)
    },
    toUser(type) {
      // 登录判断
      // if () {
      //   this.dialog = true
      // }
      let pathName
      // if(type === 'account'){

      // }else
      type === 'account' ? (pathName = 'centerMain-account') : (pathName = 'centerMain-order-order')
      this.$router.push({
        name: pathName
      })
      // window.open(page.href, '_blank')
    },
    toCenter() {
      this.checkAndtoPage(() => {
        this.$router.push({
          name: 'centerMain-account'
        })
      })
    },
    checkAndtoPage(fn) {
      // fn()
      if (this.userToken) {
        fn()
      } else {
        this.$store.commit('system/toggleLogin', true)
      }
    },
    // 打开搜索
    searchDom(type) {
      if (type === 'on') {
        this.search = search2
      } else {
        this.search = search1
      }
    },
    // 处理滚动事件
    handleScroll() {
      this.isScrolled = window.scrollY > 10
    }
  }
}
</script>

<style lang="scss" scoped>
// .drawer-box::v-deep.v-navigation-drawer {
//   width: 100% !important;
// }
//-----------------------------------------
$paddingNav: 100px;
$paddingMenu: 60px;
#nav-logo {
  width: 137px;
  cursor: pointer;
}
.system-header > a {
  display: flex;
  align-items: center;
}
.header {
  position: sticky;
  top: 0;
  z-index: 3;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.header.scrolled {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.header ::v-deep .nav-box-pc.v-app-bar {
  height: fit-content !important;
  z-index: 2;
  border-bottom: 1px solid #f0f2f4;
  transition: all 0.3s ease;
}

.nav-box-pc ::v-deep .v-toolbar__content {
  flex-direction: column;
  background-color: #fff;
  height: auto !important;
  padding: 0;
  transition: all 0.3s ease;
}

.nav-box-pc .system-header {
  width: 100%;
  height: 70px;
  display: flex;
  align-content: center;
  align-items: center;
  padding: 0 $paddingNav;
  max-width: 1720px;
  margin: 0 auto;
  transition: all 0.3s ease;
}
.tab-box {
  display: flex;
  list-style: none;
  height: 100%;
  align-items: center;
  margin-left: 50px;

  .tab-text {
    position: relative;
    font-size: 16px;
    white-space: nowrap;
    margin-right: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    box-sizing: border-box;
    cursor: pointer;
    padding: 0 10px;
    border-radius: 4px;
    transition: all 0.3s ease;
  }

  .tab-text:hover {
    background-color: rgba(48, 103, 242, 0.05);
    transform: translateY(-1px);
  }

  .tab-text.active {
    a {
      color: #3067f2 !important;
      font-weight: 600;
    }
    &:after {
      content: '';
      width: 100%;
      height: 3px;
      background: #3067f2;
      position: absolute;
      top: calc(100% - 1px);
      left: 0;
      border-radius: 2px;
    }
  }

  a {
    color: #2b2e33 !important;
    text-decoration: none;
    transition: all 0.3s ease;
  }

  .tab-text:hover a {
    color: #3067f2 !important;
  }

  .tab-text::after {
    content: '';
    width: 0;
    height: 3px;
    background: #3067f2;
    position: absolute;
    top: calc(100% - 1px);
    left: 50%;
    transition: all 0.3s ease;
    border-radius: 2px;
  }

  .tab-text:hover::after {
    left: 0%;
    width: 100%;
  }
}
.input-search {
  height: 38px;
  width: 130px;
  min-width: 100px;
  border-radius: 25px;
  background: rgba(107, 126, 153, 0.1);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  font-size: 16px;
  color: #525861;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  &:hover {
    background: #3067f2;
    color: #fff;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(48, 103, 242, 0.3);
  }

  .search-icon {
    height: 16px;
    margin: 0 15px;
    transition: all 0.3s ease;
  }

  span {
    font-size: 15px;
    transition: all 0.3s ease;
  }

  input {
    width: 194px;
    height: 16px;
    font-size: 14px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    outline: 0;
    padding: 0 8px;
    background: transparent;
    border: none;
    color: inherit;
  }

  input {
    border-radius: 30px;
  }

  &:focus-within {
    width: 200px;
    background: #3067f2;
    color: #fff;
    box-shadow: 0 4px 12px rgba(48, 103, 242, 0.4);
  }
}
.option-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin-left: 15px;
  .option {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 100%;
    cursor: pointer;
    padding: 0 10px;
    &:hover {
      background: rgba(157, 158, 158, 0.486);
    }
    .items {
      display: inline-block;
      // margin-left: 26px;
      // margin-right: 2px;
    }
    .img1 {
      width: 22px;
      height: 20px;
    }
    .img2 {
      width: 23px;
      height: 20px;
      margin-right: 4px;
    }
    .img3 {
      width: 22px;
      height: 21px;
    }
  }
  .line {
    height: 14px;
    width: 1px;
    background: #cfd8e5;
    margin: 0 26px;
  }
}
.nav-item {
  position: relative;
  display: flex;
  align-items: center;
}
.flag-num {
  display: block;
  position: absolute;
  top: 14px;
  right: 0px;
  min-width: 18px;
  padding: 0 5px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  font-size: 12px;
  border-radius: 9px;
  background-color: #f05654;
  color: #fff;
}
.center-list {
  min-height: 120px;
  width: 345px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  }

  .content {
    font-size: large;
    text-align: center;
  }

  .my-btn {
    border: 1px solid #e0e0e0 !important;
    margin-bottom: 12px;
    height: 44px !important;
    border-radius: 6px !important;
    transition: all 0.3s ease;
  }

  .item > .my-btn:hover {
    background: #3067f2 !important;
    border: 1px solid #3067f2 !important;
    color: #fff !important;
    transform: translateY(-1px);
  }

  .logo-user {
    height: 40px;
    margin-bottom: 16px;
  }

  .header-name {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 20px;
    font-weight: 600;
    color: #3067f2;
    padding: 32px 0;
    line-height: 1;
  }

  .item {
    color: #2b2e33;
    padding: 20px 46px;
    border-top: 1px solid #f0f0f0;
    border-bottom: 1px solid #f0f0f0;

    p {
      padding: 10px 16px;
      margin-bottom: 4px;
      cursor: pointer;
      transition: all 0.3s ease;
      border-radius: 4px;
    }

    p:hover {
      color: #3067f2;
      background: rgba(48, 103, 242, 0.05);
      transform: translateX(4px);
    }
  }

  .footer-option {
    padding: 12px 0;
    cursor: pointer;
    color: #2b2e33;
    transition: all 0.3s ease;

    &:hover {
      color: #3067f2;
    }
  }

  .top {
    padding: 34px 46px 20px;
  }

  .other-tips {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;

    .line {
      height: 1px;
      width: 100%;
      background: #e0e0e0;
    }

    .tips {
      flex-shrink: 0;
      font-size: 12px;
      font-weight: 400;
      color: #999;
      margin: 0 12px;
    }
  }

  .other {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin: 20px 15px 0;

    .login-item {
      display: flex;
      align-items: center;
      height: 36px;
      padding: 0 16px;
      cursor: pointer;
      border-radius: 18px;
      background: #f9f9f9;
      transition: all 0.3s ease;

      img {
        height: 18px;
        margin-right: 8px;
      }

      &:hover {
        background: #f0f0f0;
        transform: translateY(-1px);
      }
    }
  }

  .btn-login {
    color: #fff;
    height: 45px !important;
    border-radius: 6px !important;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(48, 103, 242, 0.3);
    }
  }

  .btn-register {
    margin-top: 10px;
    height: 45px !important;
    color: #3067f2 !important;
    border-radius: 6px !important;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(48, 103, 242, 0.05) !important;
      transform: translateY(-1px);
    }
  }
}
.language {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(48, 103, 242, 0.05);
    transform: translateY(-1px);
  }

  .language-icon {
    width: auto;
    height: 16px;
  }

  .open {
    width: 6px;
    height: 3px;
    margin-left: 6px;
    transition: transform 0.3s ease;
  }

  &:hover .open {
    transform: rotate(180deg);
  }

  .language-text {
    font-size: 14px;
    margin: 0 8px;
    font-weight: 500;
  }
}
// 货币 (单语言)
.currency-box {
  display: flex;
  align-items: center;
  .language-text {
    font-size: 15px;
    margin-left: 5px;
    line-height: 1;
  }
}
// 切换货币  (多货币)
.currency {
  padding-top: 0;
  padding-bottom: 0;
  width: 150px;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  overflow: hidden;

  .v-list-item__title {
    text-align: center;
    font-size: 14px;
    transition: all 0.3s ease;
  }

  .v-list-item {
    transition: all 0.3s ease;

    &:hover {
      background: rgba(48, 103, 242, 0.1);
      color: #3067f2;
      transform: translateX(4px);
    }
  }

  .v-list-item--active {
    background: rgba(48, 103, 242, 0.1);
    font-weight: 600;
  }

  .country {
    position: relative;
    top: 2px;
    width: auto;
    height: 16px;
    margin-right: 8px;
  }
}
// -------------------------
/*设置动画*/
.fade-enter,
.fade-leave-to,
.fade-leave {
  transform: rotate3d(180, 0, 0, 90deg);
  // opacity: 0;
}
// .fade-leave {
//   transition: 0.8s;
//   display: none;
// }
.fade-enter-active {
  transition: 0.7s;
}
.fade-leave-active {
  transition: 0.4s;
}
.fade-enter-to {
  transform: rotate3d(180, 0, 0, 0deg);
  // opacity: 1;
}
</style>
<style scoped lang="scss">
@media screen and (max-width: 1600px) {
  .tab-box {
    margin-left: 40px;
    padding-left: 0;
  }
}

@media screen and (max-width: 1460px) {
  .input-search .search-icon {
    margin: 0 10px;
  }
}
@media screen and (max-width: 1440px) {
  .nav-box-pc .system-header {
    padding: 0px 60px;
  }
  .tab-box .tab-text {
    // font-size: 22px;
    margin-right: 22px;
  }
  .input-search .search-icon {
    margin: 0 10px;
  }
}
</style>
<style scoped lang="scss">
@media screen and (max-width: 1280px) {
  .nav-box-pc .system-header {
    padding: 0 15px;
  }
}
</style>
<style scoped lang="scss">
@media screen and (max-width: 1260px) {
  .nav-box-mobile ::v-deep .v-toolbar__content {
    background-color: #ffffff;
    z-index: 2;
    transition: all 0.3s ease;
  }

  .header ::v-deep .nav-box-mobile.v-app-bar {
    height: fit-content !important;
    z-index: 2;
    border-bottom: 1px solid #f0f2f4;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
  }

  .nav-box-mobile ::v-deep .v-toolbar__content {
    flex-direction: column;
    background-color: #fff;
    height: auto !important;
    padding: 0;
    transition: all 0.3s ease;
  }

  .nav-box-mobile .system-header {
    width: 100%;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    transition: all 0.3s ease;
  }

  .left-nav,
  .center-nav,
  .right-nav {
    display: flex;
    align-items: center;
  }

  .center-nav a {
    display: flex;
    align-items: center;
  }

  .menu-iocn {
    width: 25px;
    height: 24px;
    margin-right: 22px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.1);
    }
  }

  .m-logo {
    width: 121px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.05);
    }
  }

  .m-search {
    width: 20px;
    height: 19px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.1);
    }
  }

  .cart-icon {
    width: 25px;
    height: 22px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.1);
    }
  }

  .user-icon {
    width: 24px;
    height: 22px;
    margin-left: 22px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.1);
    }
  }

  .nav-item {
    position: relative;
    display: flex;
    align-items: center;
    padding: 8px;
    border-radius: 6px;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(48, 103, 242, 0.05);
    }
  }

  .flag-num {
    top: -8px;
    right: -8px;
    min-width: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    font-weight: 600;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
}
</style>
